import { Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { ApiInterface } from '../api-interface';
import { ApiService } from '../api.service';
import { Observable } from 'rxjs';
import { RelatorioListaProdutosParams } from '../../models/relatorios/relatorio-lista-produtos.model';

@Injectable({
  providedIn: 'root',
})
export class RelatorioListaProdutosService implements ApiInterface {

  constructor(private apiService: ApiService) { }

  get<T>(url: string, data?: any): Observable<any> {
    const queryParams = this.apiService.buildQueryParams(data);
    const patch = queryParams ? `${url}?${queryParams}` : url;
    return this.apiService.read<any>(patch);
  }
  getText<T>(url: string, data?: any): Observable<any> {
    const queryParams = this.apiService.buildQueryParams(data);
    const patch = queryParams ? `${url}?${queryParams}` : url;
    return this.apiService.readText<any>(patch);
  }
  getById<T>(url: string): Observable<any> {
    throw new Error('Method not implemented.');
  }
  post<T>(url: string, data: any): Observable<any> {
    throw new Error('Method not implemented.');
  }
  put<T>(url: string, data: any): Observable<any> {
    throw new Error('Method not implemented.');
  }
  delete<T>(url: string): Observable<any> {
    throw new Error('Method not implemented.');
  }

  // Método para emitir o relatório de lista de produtos
  emitirRelatorio(params: RelatorioListaProdutosParams): Observable<HttpResponse<string>> {
    const queryParams = this.apiService.buildQueryParams(params as any);
    const url = queryParams
      ? `/relatorios/relatorio-de-itens?${queryParams}`
      : '/relatorios/relatorio-de-itens';
    return this.apiService.readTextWithResponse(url);
  }
}
